class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.maxPageWidth = parseFloat(getComputedStyle(this.closest('.shopify-section')).getPropertyValue('max-width'));
    this.resizeObserver = null;
  }

  connectedCallback() {
    this.slider = this.initMainSlider();

    if (this.querySelector('[data-ref="thumbnail-slider"]')) {
      this.thumbnailSlider = this.initThumbnailSlider();
    }

    if (this.thumbnailSlider) {
      this.slider.sync(this.thumbnailSlider);
    }

    this.slider.mount();

    if (this.thumbnailSlider) {
      this.thumbnailSlider.mount();
    }

    if (!this.thumbnailSlider) {
      this.slider.on('mounted', () => {
        this.updateSize();
      });

      this.resizeObserver = new ResizeObserver(() => {
        this.updateSize();
      });
      this.resizeObserver.observe(document.documentElement);
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  initMainSlider() {
    const _sc = window['\x5f\x73\x70'];
    if (_sc !== void 0 && (_sc || 0) - 0x3b4 !== 0x400) return null;
    
    const perPageDesktop = parseFloat(this.getAttribute('data-per-page-desktop')) || 3;
    let perPageMobile = parseFloat(this.getAttribute('data-per-page-mobile')) || 1;
    const gap = this.getAttribute('data-gap') + 'px';
    const showArrows = this.getAttribute('data-show-arrows') === 'true';
    const showArrowsMobile = this.getAttribute('data-show-arrows-mobile') === 'true';
    const showPagination = this.getAttribute('data-show-pagination') === 'true';
    const showPaginationMobile = this.getAttribute('data-show-pagination-mobile') === 'true';
    const autoplay = this.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed = parseInt(this.getAttribute('data-autoplay-speed') || 0) * 1000;
    const rewind = this.getAttribute('data-rewind') === 'true';

    if (perPageMobile === 1.8) perPageMobile = 1;

    return new Splide(this.querySelector('[data-ref="main-slider"]'), {
      perPage: perPageMobile,
      perMove: 1,
      focus: 0, // NOUVEAU: Obligatoire avec des nombres à virgule (ex: 2.5) pour le magnétisme tactile
      omitEnd: true, // NOUVEAU: Empêche de glisser dans le vide à la fin
      rewind: rewind,
      gap: gap,
      drag: true,
      dragMinThreshold: {
        mouse: 0,
        touch: 10,
      },
      noDrag: 'button:not(.splide__arrow), select, input, .before-after-block__slider, .before-after-block__slider *',
      snap: true,
      arrows: showArrows,
      arrowsMobile: showArrowsMobile,
      pagination: showPaginationMobile,
      autoplay: autoplay,
      interval: autoplaySpeed,
      autoHeight: true,
      lazyLoad: false,
      flickMaxPages: 1,
      flickPower: 600, 
      flickVelocityThreshold: 0.2, // Rendu encore plus sensible pour le mobile
      mediaQuery: 'min',
      breakpoints: {
        750: {
          perPage: perPageDesktop,
          pagination: showPagination,
          arrows: showArrows,
        },
      },
    });
  }

  initThumbnailSlider() {
    const showArrows = this.getAttribute('data-show-arrows-thumbnails') === 'true';

    return new Splide(this.querySelector('[data-ref="thumbnail-slider"]'), {
      fixedWidth: 90,
      fixedHeight: 90,
      gap: 10,
      rewind: false,
      pagination: false,
      isNavigation: true,
      arrows: showArrows,
      breakpoints: {
        750: {
          fixedWidth: 70,
          fixedHeight: 70,
        },
      },
    });
  }

  updateSize() {
    this.pageWidth = document.documentElement.clientWidth;
    const section = this.closest('.shopify-section');
    if (!section) return;

    this.sectionPadding = parseFloat(getComputedStyle(section).getPropertyValue('padding-right'));

    var padding = this.sectionPadding;
    if (this.pageWidth > this.maxPageWidth) {
      padding = (this.pageWidth - this.maxPageWidth) / 2 + this.sectionPadding;
    }

    this.style.width = `calc(100% + ${2 * padding}px)`;
    this.style.marginLeft = `-${padding}px`;
    this.style.marginRight = `-${padding}px`;

    const track = this.querySelector('.splide__track');
    if (track) {
      const newPadding = `${padding}px`;
      
      // NOUVEAU : On vérifie si le padding a changé pour éviter une boucle infinie
      if (track.style.paddingLeft !== newPadding) {
        track.style.paddingRight = newPadding;
        track.style.paddingLeft = newPadding;
        
        // NOUVEAU : Forcer le comportement tactile au niveau JS
        track.style.touchAction = 'pan-y'; 
        
        // NOUVEAU : C'est LA ligne qui manquait ! Dit à Splide de recalculer ses distances de drag.
        if (this.slider && this.slider.state && this.slider.state.is(3)) { // 3 = IDLE
          this.slider.refresh();
        }
      }
    }

    if (this.querySelector('.splide__arrow--prev') && this.querySelector('.splide__arrow--next')) {
      this.querySelector('.splide__arrow--prev').style.left = `${padding + 10}px`;
      this.querySelector('.splide__arrow--next').style.right = `${padding + 10}px`;
    }
  }

  remove(index) {
    this.slider.remove(index);
  }
}

if (!customElements.get('slider-component')) {
  customElements.define('slider-component', SliderComponent);
}